export default __webpack_public_path__ + "static/media/cylinderpreview.991efcdb.png";